import { render } from "./Other.vue?vue&type=template&id=5c870c92"
import script from "./Other.vue?vue&type=script&lang=js"
export * from "./Other.vue?vue&type=script&lang=js"
script.render = render

export default script